export const formatCurrency = (amount: number) => {
  if (amount < 0) {
    return `-$${Math.abs(amount).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  } else {
    return `$${amount.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  }
};

export const formatNumberCommas = (amount: number) => {
  const flooredNumber = Math.floor(amount);
  return flooredNumber.toLocaleString('en-US', {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  });
};

export const splitCurrencyParts = (amount: number) => {
  const formatted = amount.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const [dollars, cents] = formatted.split('.');
  return { dollars, cents };
};

export const formatNumberCommasWithDollar = (amount: number) => {
  const flooredNumber = Math.floor(amount);
  if (flooredNumber < 0) {
    return `-$${Math.abs(flooredNumber).toLocaleString('en-US', {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    })}`;
  } else {
    return `$${flooredNumber.toLocaleString('en-US', {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    })}`;
  }
};

export const formatNumberWithCommas = (
  value: number | string | undefined | null
) => {
  const num = Number(value);
  if (!value || isNaN(num)) return '';
  return num.toLocaleString();
};

export const unformatNumber = (value: string) => value.replace(/[^\d]/g, '');
